import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import axios from 'axios';
import Loading from '../../Components/Loading/Loading';
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import { getDateFromISOString, getTimeFromISOString } from "../../Values/utils";
import { googleAnalytics } from '../../Services/users';
import axiosHandler from '../../Services/axiosHandler';
import { themeColors } from '../../Components/theme';
import { url, contactFilterValues } from '../../Values/constants';
import {
  DELETED_LOGS_COLUMN,
  datesField,
  booleanObject,
} from "../../Values/tables";
import styles from "../Settings/Settings.module.css";
import "./AuditLog.css";
import moment from "moment";
import Firebase from "firebase/app";
import {
  setFilterObject,
  setRefreshContacts,
  showSnackbarAction,
  clearAllFilters
} from "../../Redux/actions";
// import DeleteSelectedModal from "../../Components/Modals/DeleteSelectedModal/DeleteSelectedModalsoftDelete";
import{getDeletedContactsFilter} from "../../Services/contacts"

type Props = {
    user: any;
    organizationUsers: any;
    filterObject: any;
    filterSort: any;
    authToken: any;
    organizationData: any;
    setSelectedRow: (data: any) => void;
    setSelectedData: (data: any) => void;
    setLoad:any
  
  };
  
  const DeletedContacts: FunctionComponent<Props> = ({
    user,
    organizationUsers,
    filterObject,
    filterSort,
    authToken,
    setSelectedRow,
    setSelectedData,
    setLoad

  }) => {
    let dispatcher = useDispatch();
    let isFinished = false;
    const [show, setShow] = useState(false);
    // const [load, setLoad] = useState<boolean>(false)

    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
   
    const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  
    const [lastPage, setLastPage] = useState(-1);
  
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    // const [load, setLoad] = useState(false);
   
    const [totalCounts, setTotalCounts] = useState<any>();
    const [userMap, setUserMap] = useState<any>(undefined);
    const [userBranchMap, setBranchMap] = useState<any>(undefined);
    const [userTeamMap, setTeamMap] = useState<any>(undefined);
  
   
    const [userEmail, setUserEmail] = useState<any>(undefined);
    const [showColumns, setShowColumns] = useState<any>(null);
  
    const history = useHistory();
    const location = useLocation();
  
    useEffect(() => {
      if(selectedRows){
        setSelectedRow(selectedRows)
      }

      if(selectedRowsData){
        setSelectedData(selectedRowsData)
      }
    }, [selectedRows,selectedRowsData])
    const convertToFilterString = (filterObject: { [key: string]: any }): string => {
      const filters: { [key: string]: any[] } = {};
  
      Object.keys(filterObject).forEach((val) => {
        if (filterObject && filterObject[val].length > 0) {
          filters[val] = filterObject[val];
        }
      });
      return JSON.stringify(filters);
    };
  
   
    const clearSelectedRowsData = () => {
      setSelectedRowsData([]);
      setSelectedRows([]);
    };
  
    useEffect(() => {
      if (organizationUsers) {
        let uids: { [key: string]: string } = {};
        let uidsBranch: { [key: string]: string } = {};
        let uidsTeam: { [key: string]: string } = {};
        // To store info of user
        let emailInfo: { [key: string]: string } = {};
  
        organizationUsers.forEach((user: any) => {
          uids[user.user_email] = user.reporting_to;
          uidsBranch[user.user_email] = user.branch;
          uidsTeam[user.user_email] = user.team;
          emailInfo[user.user_email] = user;
        });
        setBranchMap(uidsBranch)
        setUserMap(uids);
        setTeamMap(uidsTeam)
        setUserEmail(emailInfo)
      }
    
    }, [organizationUsers]);
  
    const callApi = async (
      paginate?: boolean,
      localPageSize?: number,
      localPage?: number
    ) => {
      let initialRequestFailed = false;
      if (isFinished === true) {
        return;
      } else {
        setLoad(true);
        const filters: { [key: string]: any[] } = {};
        let feild;
    
        Object.keys(filterObject).forEach((item) => {
          if (filterObject && filterObject[item].length > 0) {
            if (item === "is_button_called" || item === "associate_status" || item === "source_status") {
              if (filterObject[item].length === 2) {
                filters[item] = [true, false];
              } else {
                filters[item] =
                  filterObject[item][0] === "True" ? [true] : [false];
              }
            } else {
              if (item === "contact_no") {
                // Handle case where item is "contact_no"
              } else filters[item] = filterObject[item];
            }
          }
        });
    
        const updatedFilters = convertToFilterString(filters);
        let records = localPageSize ? localPageSize : pageSize;
        const apiData = {
          organization_id: user.organization_id,
          uid: user.uid,
          page: localPage ? localPage : page + 1,  // Ensure correct page number
          sort: Object.keys(filterSort).length === 0 ? JSON.stringify({ modified_at: -1 }) : JSON.stringify(filterSort),
          limit: localPageSize ? localPageSize : pageSize,
          filters: updatedFilters,
        };
    
        // console.log("apiData", apiData);
    
        setLoad(true);
        try {
          const res = await axiosHandler.get(url + "/restoringLeads/fetchDeletedLogs", { params: apiData });
          let data: any = res.data.data;
          setTotalCounts(res.data.count);
          if ((data.length < records && paginate) || (data.length < records && page === 0)) {
            isFinished = true;
            setLastPage(page);
          }
          data.forEach((lead: any) => {
            lead.contactId = lead.Id;
            lead["reporting_to"] = userMap[lead.contact_owner_email];
            lead["branch"] = userBranchMap[lead.contact_owner_email];
            lead["team"] = userTeamMap[lead.contact_owner_email];
            let info = userEmail[lead.contact_owner_email];
            if (info) {
              lead.employee_id = info.employee_id ? info.employee_id : "";
              if (info.user_first_name || info.user_last_name) {
                lead.employee_name = info.user_first_name + " " + info.user_last_name;
              }
            }
            delete lead["Id"];
            Object.keys(lead).forEach((key) => {
              if (datesField.includes(key) && lead[key] !== "") {
                if (lead[key] !== null) {
                  lead[key] = Firebase.firestore.Timestamp.fromDate(
                    moment(lead[key]).toDate()
                  );
                } else {
                  lead[key] = "";
                }
              }
            });
          });
          if (paginate && filterData) {
            let newData = [...filterData, ...data];
            setFilterData(newData);
          } else {
            setFilterData(data);
          }
          setLoad(false);
        } catch (e) {
          setFilterData([]);
    
          if (page === 0 && !initialRequestFailed) {
            initialRequestFailed = true; // Set the flag to true after the first failure
            console.warn("Ignoring initial bad request.");
          } else {
            setLoad(false);
            dispatcher(showSnackbarAction("Please Try Again!!", "error"));
          }
        }
      }
    };
    
  
    useEffect(() => {
  
        if (user === undefined || user.uid === undefined) {
          setFilterData([]);
          return;
        }
        if (userMap === undefined || userTeamMap === undefined || userBranchMap === undefined) {
          setFilterData([]);
          return;
        }
        isFinished = false;
        setLastPage(-1);
        if (page !== 0) {
  
          setPage(0);
        }
        if(authToken){
          callApi(false, pageSize, 1);
        }
          
  
      
    }, [user, filterObject, filterSort,  userMap, userTeamMap, userBranchMap, authToken]);
  // console.log("page dellll",page)
    useEffect(() => {
  
        if (
          filterData &&
          filterData.length <= (page + 1) * pageSize &&
          isFinished === false
        ) {
          if (page === 0) {
            if (authToken) {
              callApi(false, pageSize);
            }
          } else {
            if (authToken) {
              callApi(true, pageSize);
            }
          }
        }
    
    }, [page, pageSize, authToken,isFinished]);
  
  
  
    useEffect(() => {
     
  
        if (user === undefined || user.uid === undefined) {
          return;
        } 
        getDeletedContactsFilter(dispatcher,user,booleanObject);
      
      
    }, [user]);
  

  
    return (

              <div style={{ minHeight: "450px", paddingTop: "10px", marginTop: "10px" }}>
                <ApiCustomTable
                  tableColumns={DELETED_LOGS_COLUMN}
                  tableRows={filterData}
                  selectedRows={selectedRows}
                  setSelectedRows={(data) => setSelectedRows(data)}
                  tableType="DeletedLogs"
                  showColumnModal={false}
                  hideColumnModal={() => {}}
                  selectedRowsData={selectedRowsData}
                  setSelectedRowsData={(data) => setSelectedRowsData(data)}
                  setPage={(val) => setPage(val)}
                  setPageSize={(val) => setPageSize(val)}
                  
                  pageSize={pageSize}
                  page={page}
                  isFinished={isFinished}
                  totalCount={totalCounts}
                  lastPage={lastPage}
                />
              </div>
    )
          
  };
  
  const mapStateToProps = (state: any) => ({
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    // filterObject: state.filter,
    // filterSort: state.filterSort,
    filterObject: state.deleteLogsFilterObj,
    filterSort: state.deleteLogsSortObj,
    refreshContacts: state.refresh.refreshContacts,
    searchString: state.searchItem.contactsSearchString,
    organizationData: state.organization.organizationData,
  });
  
  export default connect(mapStateToProps)(DeletedContacts);
   